import { render, staticRenderFns } from "./B2CargoLoginUser.vue?vue&type=template&id=fa6f332e"
import script from "./B2CargoLoginUser.vue?vue&type=script&lang=js"
export * from "./B2CargoLoginUser.vue?vue&type=script&lang=js"
import style0 from "./B2CargoLoginUser.vue?vue&type=style&index=0&id=fa6f332e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports